module.exports = __webpack_public_path__ + "img/kachel-01.d3775828.jpg";